import request from '@/utils/request'
import api from './index'
import store from '@/store'

const basePath = '/api'

export function login (params) {
  return request({
    url: `${basePath}${api.Login}`,
    method: 'get',
    params
  })
}
export function getInfo (token) {
  return request({
    url: `${basePath}${api.Login}`,
    method: 'get',
    params: { token }
  })
}
export function getCurrentUserNav (params) {
  return request({
    url: `${api.userInfo}`,
    method: 'get',
    params
  })
}
export function logout (data) {
  store.dispatch('permission/clearRoutes')
  store.dispatch('user/logout')
  return request({
    url: `${api.logout}`,
    method: 'post',
    data
  })
}
export function agentLogin (data) {
  return request({
    url: `${api.agentLogin}`,
    method: 'post',
    data
  })
}
export function merchantLogin (data) {
  return request({
    url: `${api.merchantLogin}`,
    method: 'post',
    data
  })
}
export function csrfToken (data) {
  return request({
    url: `${api.csrfToken}`,
    method: 'post',
    data
  })
}
export function authCode (data) {
  return request({
    url: `${api.authCode}`,
    method: 'post',
    data
  })
}
export function forgetPassword (data) {
  return request({
    url: `${api.forgetPassword}`,
    method: 'post',
    data
  })
}
export function agentRegister (data) {
  return request({
    url: `${api.agentRegister}`,
    method: 'post',
    data
  })
}
export function synAgentId (params) {
  return request({
    url: `${api.synAgentId}`,
    method: 'get',
    params
  })
}
export function getBdInfo (params) {
  return request({
    url: `${api.getBdInfo}`,
    method: 'get',
    params
  })
}
